module.exports = __webpack_public_path__ + "img/Qnetchange.481f76ee.png";